module.exports = __webpack_public_path__ + "static/media/check-mark.0a3a947e.svg";